import { type CheckoutTransaction, getCheckoutTransaction } from 'models';
import { useMutation } from 'query';
import { checkoutTransaction } from '../../services';

type RecordGiftByCheck = {
  id: string;
  pathname: string;
};

export const useCheckoutTransactionMutation = () =>
  useMutation<CheckoutTransaction, RecordGiftByCheck>({
    async mutationFn({ id, pathname }) {
      const { data } = await checkoutTransaction({
        body: {
          redirect_path: pathname,
        },
        routeParams: {
          id,
        },
      });

      return getCheckoutTransaction(data);
    },
  });
